export const SUPPORTED_IMAGE_EXTENSIONS = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp'];
export const SUPPORTED_VIDEO_EXTENSIONS = ['video/mp4', 'video/mov', 'video/quicktime'];
export const SUPPORTED_FILE_EXTENSIONS = [...SUPPORTED_IMAGE_EXTENSIONS, ...SUPPORTED_VIDEO_EXTENSIONS];
